import { Reveal } from "@/components/common/Reveal";
import Breadcrumbs from "@/components/common/Breadcrumbs";

// Compact inner-page header with eyebrow, title, optional description + crumbs.
export default function PageHero({ eyebrow, title, description, crumbs, children }) {
  return (
    <section className="relative border-b border-border bg-[#f9fafb] grid-tech overflow-hidden">
      <div className="container-x pt-10 pb-14 md:pt-14 md:pb-20 relative">
        {crumbs && <div className="mb-8"><Breadcrumbs crumbs={crumbs} /></div>}
        <Reveal>
          {eyebrow && <p className="eyebrow">{eyebrow}</p>}
          <h1 className="mt-4 text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-ink text-balance max-w-4xl">{title}</h1>
          {description && <p className="mt-5 text-lg text-greyish max-w-2xl">{description}</p>}
          {children}
        </Reveal>
      </div>
    </section>
  );
}
